<template>
  <div>

    <form-wizard
      color="#7367F0"
      :title="'Müşteri Tanımlama'"
      shape="square"
      :finish-button-text="isNew ? 'Tamamla' : 'Güncelle'"
      next-button-text="İlerle"
      back-button-text="Geri"
      class="mb-3"
      @on-complete="formSubmitted"
    >

      <!-- accoint details tab -->
      <tab-content
        title="Hesap Bilgileri"
        :before-change="validationForm"
      >
        <validation-observer
          ref="accountRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Domain Bilgileri
              </h5>
              <small class="text-muted">
                Hesap bilgileri bu alanda yer alacaktır.
              </small>
            </b-col>
            <b-col md="4">
              <b-form-group
                label="Firma Adı"
                label-for="name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="accountForm.name"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                label="Domain"
                label-for="domain"
              >
                <validation-provider
                  #default="{ errors }"
                  name="domain"
                  rules="required|url"
                >
                  <b-form-input
                    id="domain"
                    v-model="accountForm.domain"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            
            <b-col md="4">
              <b-form-group
                label="Short Domain (Opsiyonel)"
                label-for="short_link_domain"
              >
                <validation-provider
                  #default="{ errors }"
                  name="short_link_domain"
                >
                  <b-form-input
                    id="short_link_domain"
                    v-model="accountForm.short_link_domain"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          
          <b-row v-if="!customerData.name">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Veritabanı Bilgileri
              </h5>
              <small class="text-muted">Veri tabanı bilgilerini eksiksiz ve doğru girmeniz gerekmektedir..</small>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Host"
                label-for="db_host"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Host"
                  rules="required"
                >
                  <b-form-input
                    id="db_host"
                    v-model="dbForm.db_host"
                    placeholder="Localhost"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Veritabanı Adı"
                label-for="db_name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Veritabanı Adı"
                  rules="required"
                >
                  <b-form-input
                    id="db_name"
                    v-model="dbForm.db_name"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Kullanıcı Adı"
                label-for="db_user"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Kullanıcı Adı"
                  rules="required"
                >
                  <b-form-input
                    id="db_user"
                    v-model="dbForm.db_user"
                    :state="errors.length > 0 ? false:null"
                    placeholder="root"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Şifre"
                label-for="db_pass"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Şifre"
                >
                  <b-form-input
                    id="db_pass"
                    v-model="dbForm.db_pass"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>
      <!-- address  -->
      <tab-content
        title="Yönetici Hesabı"
        :before-change="validationFormAdmin"
        v-if="isNew"
      >
        <validation-observer
          ref="userRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Yönetici Hesabı
              </h5>
              <small class="text-muted">Yönetici hesabını giriniz, sonrasında kendisi şifre belirleyip sisteme girecektir.</small>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Ad Soyad"
                label-for="name_surname"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Ad Soyad"
                  rules="required"
                >
                  <b-form-input
                    id="name_surname"
                    v-model="user.name_surname"
                    :state="errors.length > 0 ? false:null"
                    placeholder="İsim Soyisim"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Email"
                label-for="email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="email"
                    v-model="user.email"
                    type="email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="mail adresi"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            
            <b-col md="6">
              <b-form-group
                label="Phone"
                label-for="phone"
              >
                <validation-provider
                  #default="{ errors }"
                  name="phone"
                  rules="required"
                >
                  <b-form-input
                    id="phone"
                    v-model="user.phone"
                    :state="errors.length > 0 ? false:null"
                    type="number"
                    placeholder="507 091 19 69"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

    </form-wizard>

  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
} from 'bootstrap-vue'
import { required, email } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormInvalidFeedback,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  props: {
    customerData: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  computed: {
    isNew() {
      return Object.keys(this.customerData).length === 0
    }
  },
  data() {
    return {
      accountForm: {
        name: this.customerData ? this.customerData.name : '',
        domain: this.customerData ? this.customerData.domain : '',
        short_link_domain: this.customerData ? this.customerData.short_link_domain : NULL,
      },
      dbForm: {
        db_host: this.customerData ? this.customerData.db_host : '',
        db_name: this.customerData ? this.customerData.db_name : '',
        db_user: this.customerData ? this.customerData.db_user : '',
        db_pass: this.customerData ? this.customerData.db_pass : '',
      },
      user: {  // Bu alanı doğru tanımladığınızdan emin olun
        name_surname: null,
        email: null,
        phone: null,
      },
      selectedCustomer:{}
    }
  },

  methods: {
    formSubmitted() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Müşteri Başarıyla ' + (this.isNew ? 'oluşturuldu' : 'güncellendi'),
          icon: 'EditIcon',
          variant: 'success',
        },
      })
      this.$emit('refetch-data')
      this.$emit('modal-false')
    },
    formError(message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: message,
          icon: 'InfoIcon',
          variant: 'danger',
        },
      })
    },
    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then(success => {
          if (success) {
            // Müşteri ve veritabanı bilgilerini birleştir
            const payload = {
              name: this.accountForm.name,
              domain: this.accountForm.domain,
              short_link_domain: this.accountForm.short_link_domain,
              db_host: this.dbForm.db_host,
              db_name: this.dbForm.db_name,
              db_user: this.dbForm.db_user,
              db_pass: this.dbForm.db_pass,
            }

            // Eğer yeni bir müşteri ekleniyorsa
            if (this.isNew) {
              // Müşteri bilgilerini API'ye gönder (POST)
              this.$http.post('/manage/customers', payload)
                .then(response => {
                  if(response.data.success){
                    this.selectedCustomer=response.data.data
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: response.data.message,
                        icon: 'EditIcon',
                        variant: 'success',
                      },
                    })
                    resolve(true);
                  }else{
                    reject();
                    this.formError(response.data.error)
                  }
                })
                .catch(error => {
                  console.error('Form gönderim hatası:', error);
                  reject();
                });
            } else {
              payload['id']=this.customerData.id
              // Mevcut bir müşteri güncelleniyorsa
              this.$http.put(`/manage/customers`, payload)
                .then(response => {
                  if(response.data.success){
                    resolve(true);
                  }else{
                    this.formError(response.data.error)
                    reject();
                  }
                })
                .catch(error => {
                  console.error('Form gönderim hatası:', error);
                  reject();
                });
            }
          } else {
            reject();
          }
        });
      });
    },
    validationFormAdmin() {
      return new Promise((resolve, reject) => {
        this.$refs.userRules.validate().then(success => {
          if (success) {
            const payload = {
              name_surname: this.user.name_surname,
              email: this.user.email,
              phone: this.user.phone,
              role:0,
              customer_id:this.selectedCustomer.id,
              user_type:'admin'
            }

            // Müşteri ve veritabanı bilgilerini API'ye gönder
            this.$http.post('/user', payload, {
              headers: {
                'Content-Type': 'application/json',
                'Customer-SK' : this.selectedCustomer.secret_key
              }
            })
            .then(response => {
              if(response.data.success){
                resolve(true)
              }else{
                this.formError(response.data.error)
                reject();
              }
            })
            .catch(error => {
              console.error('Form gönderim hatası:', error)
            })
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>


<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
